export { getPinyinMp3Asset, hasPinyinMp3Asset } from "#pinyin-mp3-assets";
